import { render, staticRenderFns } from "./MobileDownload.vue?vue&type=template&id=43496a22&scoped=true&"
import script from "./MobileDownload.vue?vue&type=script&lang=js&"
export * from "./MobileDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43496a22",
  null
  
)

export default component.exports